// Owner: account-settings (plan §3.2, §9.3). Authenticated layout of every settings and account page; the
// layout lives in `-SettingsLayout.tsx` and loads with the settings area, not with the app's first paint
// (plan §10.2).
import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../lib/auth';
import { SettingsLayout } from './-SettingsLayout';

export const Route = createFileRoute('/_settings')({
  beforeLoad: ({ location }) => requireSession(location),
  component: SettingsLayout,
});
